<template>
    <DownloadOptionWrapper
        v-if="hasColorSpaceSetting(exportFormat)"
        tooltip="RGB suits on-screen use. Pick CMYK for print deliverables; colours are converted to the document's CMYK profile."
    >
        <h4>Colour space</h4>

        <template #input>
            <Select v-model="colorSpace" size="small" data-testid="download-modal__indesign-color-space-select">
                <Option
                    v-for="option in INDESIGN_COLOR_SPACE_OPTIONS"
                    :key="option.value"
                    :value="option.value"
                    :data-testid="`download-modal__indesign-color-space-select-${option.value}`"
                >
                    {{ option.label }}
                </Option>
            </Select>
        </template>
    </DownloadOptionWrapper>
</template>

<script lang="ts" setup>
import { watch } from "vue";
import { type ExportFormatType } from "shared-utils/enums/exports";

import DownloadOptionWrapper from "@/components/Download/DownloadOptionWrapper.vue";
import { INDESIGN_COLOR_SPACE_OPTIONS } from "@/components/Download/consts";
import { useDownloadInDesign } from "@/composables/download/useDownloadInDesign";

const { exportFormat } = defineProps<{
    exportFormat: ExportFormatType;
}>();

const { colorSpace, hasColorSpaceSetting, resetDownloadOptions } = useDownloadInDesign();

watch(
    () => exportFormat,
    () => {
        resetDownloadOptions();
    }
);
</script>
